<template>
  <div class="result">
    <img src="@/assets/img/pic_banner.png" alt />
    <div class="nav_pos">
      当前位置：
      <label class="index" @click.stop="$router.push('/')">首页</label>
      > {{ pageType }}
    </div>
    <div class="msg_content">
      <div class="title">{{ pageType + '进度' }}</div>
      <div class="list">
        <div class="item" v-for="(item, index) in msgList" :key="index">
          <div class="name">{{ item.title }}</div>
          <div class="msg">{{ item.msg }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      height: document.body.clientHeight - 270 + 'px',
      auditState: '',
      userName: '',
      sysNo: '',
      supplierCategory: '',
      loginName: '',
      InstanceId: this.$route.query.InstanceId,
      pageType: this.$route.query.PageType,
      msgList: [
        {
          title: '申请时间',
          msg: ''
        },
        {
          title: '审核状态',
          msg: ''
        },
        {
          title: '审核意见',
          msg: ''
        },
        {
          title: '说明',
          msg: '提交信息申请后，一般1-2个工作日完成审核'
        }
      ]
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      let that = this

      this.getRequest('/SupplierLogin/FlowDetail?InstanceId=' + that.InstanceId)
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            that.hideLoading()
            that.msgList[0].msg = data.createDate
            that.msgList[1].msg = data.auditState
            that.msgList[2].msg = data.auditContent
            that.auditState = data.auditState
            that.userName = data.userName
            that.sysNo = data.sysNo
            that.supplierCategory = data.supplierCategory
            that.loginName = data.loginName
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.result {
  .btn_1 {
    font-weight: bold;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin: 25px 0 40px;
    width: 160px;
  }
  .msg_content {
    .title {
      padding: 10px 0;
      margin: 0 35px;
      font-size: 16px;
      font-weight: bold;
      text-align: center;
      border-bottom: 1px solid #95c7f0;
    }
    .list {
      margin: 15px 50px;
      .item {
        display: flex;
        align-items: stretch;
        .name {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          flex: 0 0 150px;
          padding: 15px 5px;
          border: 1px solid #fff;
          background: #d8eafa;
          text-align: right;
        }
        .msg {
          flex: 1;
          padding: 15px 5px;
          border: 1px solid #fff;
          background: #f2f2f2;
        }
      }
    }
  }
}
</style>
